export function EnseignesActions({ children, selectedItems, onDeselectAll }) {}
